var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_855_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 0C12.4184 0 16 3.58162 16 8.00017C16 12.4187 12.4184 16.0003 7.99983 16.0003C3.58128 16.0003 -0.000339508 12.4187 -0.000339508 8.00017C0.00511551 3.584 3.58366 0.00511367 7.99983 0ZM4.91458 10.0576C4.62583 10.3364 4.61765 10.797 4.89685 11.0861C5.17572 11.3749 5.63629 11.383 5.92538 11.1038C5.93152 11.098 5.93732 11.0919 5.94311 11.0861L7.99983 9.0287L10.0565 11.0861C10.3453 11.3653 10.8059 11.3571 11.0851 11.0684C11.3571 10.7864 11.3571 10.3398 11.0851 10.0579L9.02836 8.00051L11.0851 5.94311C11.3738 5.6639 11.382 5.20367 11.1028 4.91458C10.8236 4.62583 10.3634 4.61765 10.0743 4.89685C10.0681 4.90265 10.0623 4.90878 10.0565 4.91458L7.99983 6.97198L5.94311 4.91458C5.66391 4.62583 5.20367 4.61765 4.91458 4.89685C4.62583 5.17606 4.61765 5.63629 4.89685 5.92538C4.90265 5.93152 4.90878 5.93731 4.91458 5.94311L6.9713 8.00051L4.91458 10.0579V10.0576Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_855_2088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseB);
export default __webpack_public_path__ + "static/media/CloseB.cef3b14768dcff3a15b067f82daeca56.svg";
export { ForwardRef as ReactComponent };